export enum Behaviour {
  'CONTINUE' = 'Continue Last Value',
  'REVERSE' = 'Reverse',
  'WRAP AROUND' = 'Wrap around',
  'STOP BATCH' = 'Stop Batch'
}